"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
const branding_service_1 = require("./branding.service");
let NotificationService = class NotificationService {
    constructor(_modal, _branding) {
        this._modal = _modal;
        this._branding = _branding;
    }
    handle(error) {
        console.error('An error occurred', error);
        /*this._modal.alert() //this wont work because 'this' will be broken
            .size('lg')
            .showClose(true)
            .title(this._branding.getProductName())
            .body(`Oops. It looks like there was an issue performing that action! Please try again, check out our <a routerLink="/help">Help</a> page, or contact us for support <i class="fa fa-smile-o" aria-hidden="true"></i>`)
            .open();*/
        return Promise.reject(error.message || error);
    }
    broadcast(body) {
        return this._modal.alert()
            .size('lg')
            .showClose(true)
            .title(this._branding.getProductName())
            .body(body)
            .open();
    }
    ask(body) {
        return this._modal.prompt()
            .size('lg')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .title(this._branding.getProductName())
            .body(body)
            .open();
    }
    confirm(body) {
        return this._modal.confirm()
            .size('lg')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .title(this._branding.getProductName())
            .body(body)
            .open();
    }
    save(body) {
        return this._modal.confirm()
            .size('lg')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .body(body)
            .title(this._branding.getProductName())
            .okBtn('Save Changes')
            .okBtnClass('btn btn-success')
            .cancelBtn('Do Not Save Changes')
            .cancelBtnClass('btn btn-danger')
            .open();
    }
};
exports.NotificationService = NotificationService;
exports.NotificationService = NotificationService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [bootstrap_1.Modal,
        branding_service_1.BrandingService])
], NotificationService);
//# sourceMappingURL=notification.service.js.map